import { useFilterPanelMobileActions } from "./use-mobile-actions";
import { FilterPanelMobileActionsView } from "./view-mobile-actions";

export function FilterPanelMobileActions() {
  const viewModel = useFilterPanelMobileActions();

  return <FilterPanelMobileActionsView {...viewModel} />;
}
FilterPanelMobileActions.displayName = "FilterPanel.MobileActions";
